import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProgramElementComponent } from './components/program-element/program-element.component';
import { LearnersComponent } from './components/learners/learners.component';
import { FaqComponent } from './components/faq/faq.component'

const routes: Routes = [
  { path: '', component: DashboardComponent  },
  { path: 'block', component: ProgramElementComponent  },
  { path: 'block/:id', component: ProgramElementComponent  },
  { path: 'learners', component: LearnersComponent  },
  { path: 'faq', component: FaqComponent  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerDashboardRoutingModule { }
